export default "__VITE_ASSET__829f2d5f__"